import { render, staticRenderFns } from "./commissionManagement.vue?vue&type=template&id=be7c43e4&scoped=true"
import script from "./commissionManagement.vue?vue&type=script&lang=js"
export * from "./commissionManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be7c43e4",
  null
  
)

export default component.exports